module.exports = __webpack_public_path__ + "static/media/French_Poland.0e431194.jpeg";